import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import checkIcon from "./icon/Check.png";

const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: 'rgba(171, 171, 171, 0.1)',
    //height: '55px',
    margin: '.3rem 0 1rem 0',
  },
  total: {
    display: 'flex',
    marginTop: 30,
    justifyContent: 'center',
    alignItems: 'center',
    '& h6': {
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
      fontWeight: 700,
    },
  },
  blockInputError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  subTitle: {
    margin: "0px 20px",
    fontFamily: "FuturaStdBold",
    fontSize: "30px",
    fontWeight: 700,
    color: "#262857",
    lineHeight: "36px",
    '& span': {
      color: "#e84249"
    }
  },
  subTitle2: {
    fontFamily: "FuturaStdBook",
    fontSize: "30px",
    fontWeight: 300,
    margin: "0px 20px",
    color: "#262957",
    lineHeight: "30px"
  },
}));

const TicketRequestForm = () => {
  const classes = useStyles();

  return (
    (
      <Grid container className={classes.root}>
        <Grid item xs={12} className={classes.total}>
          <img src={checkIcon} width="130px"/>
        </Grid>
        <Grid item xs={12} className={classes.total}>
          <Typography align="center" className={classes.subTitle}>
              Tout est bon !
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.total}>
          <Typography align="center" className={classes.subTitle2}>
           Vous recevrez un email dès que vos tickets seront disponibles en ligne.
          </Typography>
        </Grid>
      </Grid>
    )
  )
}

export default TicketRequestForm;